"use client"
import React from 'react'
import styles from "./Webinar.module.scss"
import clsx from "clsx"; 

interface WebinarCardProps {
  Webinar?:WebinarUI;
  item?:ContentComponentType
  }

const WebinarCard = ({item
    
  }: WebinarCardProps) => {
  return (
    <section className="mt-10 md:px-6">
       <div className={styles.webinarContainer}>
        <div className={clsx(styles.webinarCard, styles.headingbackground )}>
          <img className={styles.pointIcon}  src={item?.Icon?.data?.attributes?.url} />
          <div dangerouslySetInnerHTML={{ __html: item?.ContentTitle }} className={styles.webinarCardHeading}/>
        </div>
        <div className={styles.listItem}>
        <div dangerouslySetInnerHTML={{ __html: item?.Content.replace("&nbsp;","").replaceAll("","") }}/>
        </div>
      </div>
    </section>
  );
}

export default WebinarCard
